import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";

class VitalSignExam {
    public Value: number | null;
    public Value2: number | null;
    public Unit: string | null;
    public Date: Date;

    public constructor(init?: NonFunctionProperties<VitalSignExam>) {
        Object.assign(this, init);
    }
}

export { VitalSignExam };
